export enum CallAlertResponse {
  ACCEPT = 'accept',
  DECLINE = 'decline',
}
